module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "component",
    staticClass: "z-date",
    class: _vm.classes
  }, [(_vm.label) ? _c('label', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }), _vm._v(" "), (_vm.required) ? _c('span', [_vm._v(" *")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.$props.format,
      "type": _vm.$props.type,
      "clearable": "",
      "confirm": "",
      "confirm-text": "Сохранить",
      "disabled": _vm.$props.disabled,
      "placeholder": _vm.$props.placeholder
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [(_vm.$props.reset) ? _c('template', {
    slot: "footer"
  }, [_c('button', {
    staticClass: "mx-btn mx-datepicker-btn-confirm z-date__reset",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onReset
    }
  }, [_vm._v(_vm._s(_vm.$props.resetText))])]) : _vm._e()], 2), _vm._v(" "), (_vm.$props.error) ? _c('span', {
    staticClass: "z-error"
  }, [_vm._v(_vm._s(_vm.$props.error))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05575714","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZDate.vue
// module id = 1024
// module chunks = 0